import { render, staticRenderFns } from "./eventNotification.vue?vue&type=template&id=6bba0a65&scoped=true&"
import script from "./eventNotification.vue?vue&type=script&lang=js&"
export * from "./eventNotification.vue?vue&type=script&lang=js&"
import style0 from "./eventNotification.vue?vue&type=style&index=0&id=6bba0a65&lang=scss&scoped=true&"
import style1 from "./eventNotification.vue?vue&type=style&index=1&id=6bba0a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bba0a65",
  null
  
)

export default component.exports